import React, { Dispatch, SetStateAction, useState } from 'react';

export type Heading = {
  id: string;
  value: string;
  depth: number;
};

const HeadingContext = React.createContext<
  | {
      headings: Heading[];
      setHeadings: Dispatch<SetStateAction<Heading[]>>;
    }
  | undefined
>(undefined);

export default HeadingContext;

export const HeadingContextProvider = ({
  children,
  defaultHeadings,
}: {
  children: React.ReactNode;
  defaultHeadings?: Heading[];
}) => {
  const [headings, setHeadings] = useState<Heading[]>(defaultHeadings || []);

  return (
    <HeadingContext.Provider value={{ headings, setHeadings }}>
      {children}
    </HeadingContext.Provider>
  );
};
